<template>
  <div class="container" @paste="handlePaste">
    <el-scrollbar
      id="menuWarpper"
      style="height: calc(99%); background-color: #ffffff; margin-top: 0px"
    >
      <div class="main">
        <!-- <el-button class="fanhuiBtn" @click="fanhui()">返回</el-button> -->

        <div
          v-if="
            CustomerInfo !== null &&
            CustomerInfo !== '' &&
            CustomerInfo !== {} &&
            CustomerInfo.PayBeginDate !== undefined
          "
        >
          <div class="yonghuminglabe">新建工单</div>
          <div
            v-if="CustomerInfo.IsDelegate == 0"
            style="
              width: 33%;
              padding-top: 10px;
              text-align: right;
              display: inline-block;
              color: #2380e1;
            "
          >
            本服务周期:{{ CustomerInfo.PayBeginDate }}至{{
              CustomerInfo.PayEndDate
            }}
          </div>
          <div
            v-if="CustomerInfo.IsDelegate == 1"
            style="
              width: 40%;
              padding-top: 10px;
              text-align: right;
              display: inline-block;
              color: #2380e1;
            "
          >
            本服务周期:{{ CustomerInfo.PayBeginDate }}至{{
              CustomerInfo.PayEndDate
            }}
          </div>
          <!-- <div v-if='CustomerInfo.IsDelegate==0'
						style="width: 33%;padding-top: 20px;text-align: center;display: inline-block;color:#2380E1;">
				
						已提问题数量:{{CustomerInfo.InfoNum}}
					</div> -->
          <!-- <div v-if='CustomerInfo.IsDelegate==1'
						style="width: 55%;padding-top: 20px;text-align: center;display: inline-block;color:#2380E1;">
				
						已提问题数量:{{CustomerInfo.InfoNum}}
					</div> -->
          <!-- <div v-if='CustomerInfo.IsDelegate==0'
						style="width: 33%;padding-top: 20px;text-align: left;display: inline-block;color:#2380E1;">
						服务费金额:{{CustomerInfo.Payments}}
					</div> -->
          <!-- <div class="header-con-tabshk">
						
						<el-tabs v-model="activeTab" style="margin-left: 10px;margin-top: 18px;" type="card"
							closable @tab-remove="removeTab" @tab-click="handleClick">
							<el-tab-pane v-for="(item) in editableTabs" :key="item.title" :label="item.title"
								:name="item.path">
							</el-tab-pane>
						</el-tabs>
				
					</div> -->
        </div>
        <div class="header-con">
          <div class="maina">
            <el-form
              :model="form"
              :rules="formRule"
              ref="form"
              label-width="140px"
              label-position="right"
              style="display: inline"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    style="width: 100%"
                    label="选择客户："
                    prop="xuanzekehu"
                  >
                    <div>
                      <!-- <el-button class="medium" @click="double">{{xuanzekehu}}
									</el-button> -->
                      <el-input
                        style="width: 100%"
                        type="text"
                        v-model="form.xuanzekehu"
                        @keyup.enter.native="double"
                        placeholder="点回车查询客户"
                        ref="xuanzekehu"
                        @dblclick.native="double"
                        clearable
                      >
                      </el-input>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    style="width: 100%"
                    label="客户联系人："
                    prop="lianxiren"
                  >
                    <el-input
                      style="width: 100%"
                      type="text"
                      v-model="form.lianxiren"
                      @keyup.enter.native="doublelxr"
                      ref="lianxiren"
                      placeholder="点回车查询联系人"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    style="width: 100%"
                    label="客户联系电话："
                    prop="lianxidianhua"
                  >
                    <el-input
                      style="width: 100%"
                      type="text"
                      v-model="form.lianxidianhua"
                      ref="lianxidianhua"
                      @keyup.enter.native="xzchanpinxian"
                      placeholder="请输入您的联系电话"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    style="width: 100%"
                    label="产品线："
                    prop="person"
                  >
                    <!-- <el-select class="form-item-inputcpx" v-model="form.person" filterable remote
									reserve-keyword placeholder="输入关键词搜索" :remote-method="getPerson" :loading="loading"
									@click.native="getPerson('')">
									<el-option v-for="item in staff" :key="item.Code" :label="item.Name" :value="item.Code">
									</el-option>
								</el-select> -->
                    <el-select
                      style="width: 100%"
                      v-model="form.person"
                      filterable
                      ref="chanpinxian"
                      placeholder="输入关键词搜索"
                      :filter-method="bindSelectChange"
                      @focus="dianjichanpinxianSJ"
                      @change="dianjichanpinxian"
                      popper-class="eloption"
                      :popper-append-to-body="false"
                    >
                      <el-option
                        v-for="item in staff"
                        :key="item.Code"
                        :label="item.Name"
                        :value="item.Code"
                        :value-key="item.Code"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    style="width: 100%"
                    label="问题类型："
                    prop="wentileixing"
                  >
                    <el-select
                      style="width: 100%"
                      v-model="form.wentileixing"
                      filterable
                      ref="wentileixing"
                      placeholder="输入关键词搜索"
                    >
                      <el-option
                        v-for="item in WenTileixingList"
                        :key="item.Code"
                        :label="item.Name"
                        :value="item.Code"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    v-if="juese == 13"
                    style="width: 100%"
                    label="下发到："
                    prop="xiafadaoweijiedan"
                  >
                    <el-select
                      style="width: 100%"
                      v-model="form.xiafadaoweijiedan"
                      filterable
                      ref="xiafaweijiedan"
                      placeholder="输入关键词搜索"
                    >
                      <el-option
                        v-for="item in xiafadaoweijiedanList"
                        :key="item.Code"
                        :label="item.Name"
                        :value="item.Code"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-else
                    style="width: 100%"
                    label="下发到未接单："
                    prop="xiafadaoweijiedan"
                  >
                    <el-select
                      style="width: 100%"
                      v-model="form.xiafadaoweijiedan"
                      filterable
                      ref="xiafaweijiedan"
                      placeholder="输入关键词搜索"
                    >
                      <el-option
                        v-for="item in xiafadaoweijiedanList"
                        :key="item.Code"
                        :label="item.Name"
                        :value="item.Code"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <div v-if="form.xiafadaoweijiedan == 'Y'">
                  <el-col :span="12">
                    <el-form-item
                      style="width: 100%"
                      label="难度等级："
                      prop="xiafadaoweijiedan"
                    >
                      <el-select
                        v-model="strNycd"
                        style="width: 100%"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in optionsNY"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </div>
                <el-col :span="12">
                  <el-form-item
                    style="width: 100%"
                    label="远程工具："
                    prop="yuanchenggongju"
                  >
                    <el-select
                      style="width: 100%"
                      v-model="form.yuanchenggongju"
                      filterable
                      ref="yuanchenggongju"
                      :filter-method="bindSelectChangeyc"
                      @change="dianjichanpinxianyc"
                      placeholder="输入关键词搜索"
                      clearable
                      @focus="yuanchenggongjuSJ"
                    >
                      <el-option
                        v-for="item in YuanChengGongJuList"
                        :key="item.Code"
                        :label="item.Name"
                        :value="item.Code"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="yuanchenggongjuName != '无'">
                  <el-form-item style="width: 100%" label="远程账号：" required>
                    <el-input
                      style="width: 100%"
                      type="text"
                      ref="yuanchengzhanghao"
                      v-model="yuanchengzhanghao"
                      @keyup.enter.native="yuanchengmima"
                      placeholder="请输入您的远程账号/数据库连接"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="yuanchenggongjuName != '无'">
                  <!-- <span style="margin-top: 0px ;font-size: 14px; color: #666;">1</span> -->
                  <el-form-item
                    style="width: 100%"
                    required
                    label="远程账号密码："
                  >
                    <el-input
                      style="width: 100%"
                      type="text"
                      ref="yuanchengmima"
                      autocomplete="off"
                      v-model="yuanchengmima"
                      @keyup.enter.native="xzmiaoshu"
                      placeholder="请输入您的远程账号密码"
                    >
                    </el-input>
                  </el-form-item>
                  <el-form-item style="width: 100%; margin-top: -15px">
                    <div style="color: red">
                      远程密码需谨慎提供，工单完成后请立即修改。
                      <!-- 远程账号密码需谨慎提供，可以选择电话告知服务远程账号密码，也可以直接填写 -->
                    </div>
                  </el-form-item>
                </el-col>
                <div v-if="juese == 13">
                  <div v-if="form.xiafadaoweijiedan == 'Y'">
                    <el-col :span="12">
                      <el-form-item
                        style="width: 100%"
                        label="预计完成时间："
                        prop="yujiwanchengshijian"
                      >
                        <el-date-picker
                          style="width: 100%"
                          v-model="form.yujiwanchengshijian"
                          type="datetime"
                          placeholder="选择日期时间"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </div>

                  <div v-if="form.xiafadaoweijiedan == 'P'">
                    <el-col :span="12">
                      <el-form-item
                        style="width: 100%"
                        label="指定客服："
                        prop="yujiwanchengshijian"
                      >
                        <!-- <el-date-picker style="width:100%" v-model="form.yujiwanchengshijian"
												type="datetime" placeholder="选择日期时间">
											</el-date-picker> -->
                        <el-input
                          style="width: 100%"
                          type="text"
                          v-model="form.xuanzekefu"
                          @keyup.enter.native="doublekf"
                          placeholder="点回车查询客服"
                          @dblclick.native="doublekf"
                          clearable
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </div>
                </div>
                <div v-else>
                  <div v-if="form.xiafadaoweijiedan == 'Y'">
                    <el-col :span="12">
                      <el-form-item
                        style="width: 100%"
                        label="预计完成时间："
                        prop="yujiwanchengshijian"
                      >
                        <el-date-picker
                          style="width: 100%"
                          v-model="form.yujiwanchengshijian"
                          type="datetime"
                          placeholder="选择日期时间"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </div>
                </div>
              </el-row>
            </el-form>
          </div>
          <el-card class="mainxjgda">
            <el-form
              :model="form"
              :rules="formRule"
              ref="form"
              label-width="100px"
              label-position="right"
            >
              <el-form-item label="描述：" prop="miaoshu">
                <el-input
                  style="margin-left: 10px; width: 96%"
                  type="textarea"
                  :rows="8"
                  ref="miaoshu"
                  placeholder="请输入内容"
                  v-model="form.miaoshu"
                >
                </el-input>
              </el-form-item>

              <div class="shangchuantupian">
                <div class="shangchuantupianx">
                  <!-- <el-upload action="#" ref="pictureUpload" list-type="picture-card"
										:on-change="uploadChange" :auto-upload="false" multiple>
										<i slot="default" class="el-icon-plus"></i>
										<div slot="file" slot-scope="{file}">
											<img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
											<span class="el-upload-list__item-actions">
												<span class="el-upload-list__item-preview"
													@click="handlePictureCardPreview(file)">
													<i class="el-icon-zoom-in"></i>
												</span>
												<span v-if="!disabled" class="el-upload-list__item-delete"
													@click="handleRemove(file)">
													<i class="el-icon-delete"></i>
												</span>
											</span>
										</div>
									</el-upload> -->

                  <el-upload
                    action="#"
                    ref="pictureUpload"
                    list-type="picture-card"
                    :on-change="uploadChange"
                    drag
                    :auto-upload="false"
                    multiple
                  >
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{ file }">
                      <img
                        class="el-upload-list__item-thumbnail"
                        src="../../assets/img/wenjianmorentu.png"
                        style="height: 150px"
                        alt=""
                        v-if="
                          file.name.search('.doc') != -1 ||
                          file.name.search('.ppt') != -1 ||
                          file.name.search('.htm') != -1 ||
                          file.name.search('.txt') != -1 ||
                          file.name.search('.pdf') != -1 ||
                          file.name.search('.xls') != -1
                        "
                      />

                      <img
                        class="el-upload-list__item-thumbnail"
                        :src="file.url"
                        alt=""
                        v-if="
                          file.name.search('.png') != -1 ||
                          file.name.search('.PNG') != -1 ||
                          file.name.search('.jpg') != -1 ||
                          file.name.search('.JPG') != -1 ||
                          file.name.search('.jpeg') != -1 ||
                          file.name.search('.JPEG') != -1 ||
                          file.name.search('.PDD') != -1 ||
                          file.name.search('.pdd') != -1 ||
                          file.name.search('.PSD') != -1 ||
                          file.name.search('.psd') != -1 ||
                          file.name.search('.GIF') != -1 ||
                          file.name.search('.gif') != -1
                        "
                      />

                      <div class="wenjianmingchengzs">
                        {{ file.name }}
                      </div>
                      <video
                        ref="videoPlayer"
                        controls
                        :src="file.url"
                        controlslist="nodownload"
                        style="width: 150px; height: 200px; object-fit: fill"
                        v-if="
                          file.name.search('.mp4') != -1 ||
                          file.name.search('.flv') != -1 ||
                          file.name.search('.swf') != -1 ||
                          file.name.search('.ram') != -1 ||
                          file.name.search('.rm') != -1 ||
                          file.name.search('.mov') != -1 ||
                          file.name.search('.mpeg') != -1 ||
                          file.name.search('.mpg') != -1 ||
                          file.name.search('.wmv') != -1 ||
                          file.name.search('.avi') != -1
                        "
                      ></video>
                      <span class="el-upload-list__item-actions">
                        <span
                          class="el-upload-list__item-preview"
                          @click="handlebofangshipin(file)"
                          v-if="
                            file.name.search('.mp4') != -1 ||
                            file.name.search('.flv') != -1 ||
                            file.name.search('.swf') != -1 ||
                            file.name.search('.ram') != -1 ||
                            file.name.search('.rm') != -1 ||
                            file.name.search('.mov') != -1 ||
                            file.name.search('.mpeg') != -1 ||
                            file.name.search('.mpg') != -1 ||
                            file.name.search('.wmv') != -1 ||
                            file.name.search('.avi') != -1
                          "
                        >
                          <i class="el-icon-video-play"></i>
                        </span>
                        <span
                          class="el-upload-list__item-preview"
                          @click="handlePictureCardPreview(file)"
                          v-if="
                            file.name.search('.png') != -1 ||
                            file.name.search('.PNG') != -1 ||
                            file.name.search('.jpg') != -1 ||
                            file.name.search('.JPG') != -1 ||
                            file.name.search('.jpeg') != -1 ||
                            file.name.search('.JPEG') != -1 ||
                            file.name.search('.PDD') != -1 ||
                            file.name.search('.pdd') != -1 ||
                            file.name.search('.PSD') != -1 ||
                            file.name.search('.psd') != -1 ||
                            file.name.search('.GIF') != -1 ||
                            file.name.search('.gif') != -1
                          "
                        >
                          <i class="el-icon-zoom-in"></i>
                        </span>
                        <span
                          v-if="!disabled"
                          class="el-upload-list__item-delete"
                          @click="handleRemove(file)"
                        >
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                    </div>
                  </el-upload>
                  <el-dialog
                    width="280px"
                    height="80%"
                    :visible.sync="showShipinbofang"
                  >
                    <video
                      ref="videoPlayer"
                      controls
                      :src="bofangshipin"
                      controlslist="nodownload"
                      style="width: 240px; height: 85%; object-fit: fill"
                      v-if="showShipinbofang"
                    ></video>
                  </el-dialog>
                  <el-image-viewer
                    class="fankuiImage"
                    v-if="dialogVisible"
                    :initial-index="this.index"
                    :on-close="closeViewer"
                    :url-list="this.urlList"
                  />
                </div>
              </div>
            </el-form>
          </el-card>
          <el-col :span="9">
            <div class="shangchuantupian"></div>
          </el-col>
          <!-- 	<el-col :span="5">
						<el-button class="tijiaobtn" type="success" :disabled="scoped" @click="baocuncaogao()">保存草稿
						</el-button>
					</el-col> -->
          <el-col :span="6">
            <el-button
              class="tijiaobtn"
              type="primary"
              @click="submitForm()"
              :disabled="isTiJiao"
              >提交
            </el-button>
          </el-col>
          <el-col :span="9">
            <div class="shangchuantupian"></div>
          </el-col>
        </div>
      </div>
    </el-scrollbar>
    <!-- 选择客户 -->
    <el-dialog
      title="选择客户"
      :visible.sync="formDialog"
      width="80%"
      height="80%"
    >
      <div class="containera">
        <el-card class="headera">
          <div class="header-cona">
            <el-form
              class="header-con-form"
              :inline="true"
              @submit.native.prevent
            >
              <el-form-item class="header-con-form-item" label="客户姓名:">
                <el-input
                  v-model="form.xuanzekehu"
                  style="width: 200px"
                  placeholder="请输入"
                  ref="kehuchaxun"
                  @change="handleAddItem(1)"
                  @keyup.enter.native="handleAddItem(1)"
                >
                </el-input>
              </el-form-item>
              <el-button
                type="primary"
                @click="handleAddItem(1)"
                :disabled="isChaXun"
                >查询</el-button
              >
            </el-form>
          </div>
          <div></div>
        </el-card>
        <div class="main" v-bind:style="{ height: EchartsHeight }">
          <el-table
            :data="tableData"
            height="100%"
            highlight-current-row
            resizable
            stripe
            border
            @row-dblclick="handledbClick"
          >
            <el-table-column
              align="center"
              type="index"
              label="序号"
              width="50"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="BUSINESSNAME"
              label="客户名称"
              min-width="180"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="BUSINESSCODE"
              label="客户编号"
            >
            </el-table-column>
            <el-table-column align="center" prop="CONTACT" label="客户联系人">
            </el-table-column>
            <el-table-column
              align="center"
              prop="TELEPHONE"
              label="客户联系电话"
            >
            </el-table-column>

            <el-table-column align="center" label="操作" fixed="right">
              <template slot-scope="scope">
                <el-button type="primary" @click="viewDoc(scope)"
                  >选择</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="footer" ref="footer">
          <pagination
            :allPage="allPage"
            :pageSize="pageSize"
            :currIndex="currPage"
            @hanSiChange="hanSiChange"
            @hanCurrChange="hanCurrChange"
          ></pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="选择联系人"
      :visible.sync="formDialogLXR"
      width="80%"
      height="80%"
    >
      <div class="containera">
        <el-card class="headera">
          <div class="header-cona">
            <el-form
              class="header-con-form"
              :inline="true"
              @submit.native.prevent
            >
              <el-form-item class="header-con-form-item" label="联系人姓名:">
                <el-input
                  v-model="form.lianxiren"
                  style="width: 200px"
                  placeholder="请输入"
                  ref="lianxirenchaxun"
                  @change="XuanZeLianXiRen(1)"
                  @keyup.enter.native="XuanZeLianXiRen(1)"
                >
                </el-input>
              </el-form-item>
              <el-button
                type="primary"
                @click="XuanZeLianXiRen()(1)"
                :disabled="isChaXun"
                >查询</el-button
              >
            </el-form>
          </div>
          <div></div>
        </el-card>
        <div class="main" v-bind:style="{ height: EchartsHeight }">
          <el-table
            :data="tableDataLXR"
            height="100%"
            highlight-current-row
            resizable
            stripe
            border
            @row-dblclick="handledbClickLXR"
          >
            <el-table-column
              align="center"
              type="index"
              label="序号"
              width="50"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="CustomerName"
              label="客户名称"
              min-width="180"
            >
            </el-table-column>
            <el-table-column align="center" prop="Contacts" label="联系人">
            </el-table-column>
            <el-table-column
              align="center"
              prop="ContactsInfo"
              label="客户联系电话"
            >
            </el-table-column>

            <el-table-column align="center" label="操作" fixed="right">
              <template slot-scope="scope">
                <el-button type="primary" @click="viewDoclxr(scope)"
                  >选择</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="footer" ref="footer">
          <pagination
            :allPage="allPageLXR"
            :pageSize="pageSizeLXR"
            :currIndex="currPageLXR"
            @hanSiChange="hanSiChangeLXR"
            @hanCurrChange="hanCurrChangeLXR"
          ></pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="选择客服"
      :visible.sync="formDialogkf"
      width="80%"
      height="80%"
    >
      <div class="containera">
        <el-card class="headera">
          <div class="header-cona">
            <el-form
              class="header-con-form"
              :inline="true"
              @submit.native.prevent
            >
              <el-form-item class="header-con-form-item" label="客服姓名:">
                <el-input
                  v-model="form.xuanzekefu"
                  style="width: 200px"
                  placeholder="请输入"
                  ref="kefuchaxun"
                  @change="getKefumingdan(1)"
                  @keyup.enter.native="getKefumingdan(1)"
                >
                </el-input>
              </el-form-item>
              <el-button
                type="primary"
                @click="getKefumingdan(1)"
                :disabled="isChaXunkfm"
                >查询</el-button
              >
            </el-form>
          </div>
          <div></div>
        </el-card>
        <div class="main" v-bind:style="{ height: EchartsHeight }">
          <el-table
            :data="tableDatakf"
            height="100%"
            highlight-current-row
            resizable
            stripe
            border
            @row-dblclick="handledbClickkf"
          >
            <el-table-column
              align="center"
              type="index"
              label="序号"
              width="50"
            >
            </el-table-column>
            <el-table-column align="center" prop="NAME" label="姓名">
            </el-table-column>
            <el-table-column align="center" prop="JOB_NUMBER" label="编号">
            </el-table-column>
            <el-table-column align="center" prop="PRODUCT_LINE1" label="产品线">
            </el-table-column>
            <el-table-column align="center" prop="ROLE_NAME" label="角色">
            </el-table-column>

            <el-table-column align="center" label="操作" fixed="right">
              <template slot-scope="scope">
                <el-button type="primary" @click="viewDockf(scope)"
                  >选择</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="footer" ref="footer">
          <pagination
            :allPage="allPagekf"
            :pageSize="pageSizekf"
            :currIndex="currPagekf"
            @hanSiChange="hanSiChangekf"
            @hanCurrChange="hanCurrChangekf"
          ></pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PinyinMatch from "pinyin-match";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  components: {
    ElImageViewer,
  },

  name: "xinjiangongdan",
  data() {
    var checkMobile = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("手机号不可为空"));
      } else {
        if (value !== "") {
          var reg = /^1[3-9]\d{9}$/;
          if (!reg.test(value)) {
            callback(new Error("请输入有效的手机号码"));
          }
        }
        callback();
      }
    };
    return {
      CustomerInfo: [],
      optionsNY: [
        {
          value: 1,
          label: "一级",
        },
        {
          value: 2,
          label: "二级",
        },
        {
          value: 3,
          label: "三级",
        },
      ],
      strNycd: 1,
      isTiJiao: false,
      isChaXun: false,
      isChaXunkfm: false,
      kefubianhao: "",
      juese: JSON.parse(localStorage.getItem("userInfo")).ROLE,
      bofangshipin: "",
      showShipinbofang: false,
      EchartsHeight: document.body.clientHeight - 200 + "px",
      fileList: [],
      fileListhc: [],
      showViewer: false, // 显示查看器
      urlList: [],
      index: 0,
      kehumingcheng: "",
      kehubianhao: "",
      kehuId: "",
      currPage: 1,
      pageSize: 50,
      allPage: 0,
      currPageLXR: 1,
      pageSizeLXR: 50,
      allPageLXR: 0,
      currPagekf: 1,
      pageSizekf: 50,
      allPagekf: 0,
      WenTileixingList: [],
      YuanChengGongJuList: [],
      YuanChengGongJuListcopy: [],
      YuanChengGongJuListz: [],
      xiafadaoweijiedanList: [
        {
          Code: "W",
          Name: "未接单",
        },
        {
          Code: "Y",
          Name: "已接单",
        },
        {
          Code: "P",
          Name: "指定客服",
        },
      ],
      tableData: [], //客户数组
      tableDatakf: [],
      tableDataLXR: [],

      yonghuming: JSON.parse(localStorage.getItem("userInfo")).NAME,
      formDialog: false,
      formDialogLXR: false,
      formDialogkf: false,
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      qianyiyemingcheng: this.$route.query.qianyiyemingcheng,
      yuanchengzhanghao: "",
      yuanchengmima: "",
      lianxirenBY: "",
      lianxidianhuaBY: "",
      kefumingcheng: "",
      /**表单 */
      form: {
        miaoshu: "", //描述
        lianxiren: "",
        lianxidianhua: "",
        person: "", //产品线
        wentileixing: "", //问题类型
        xiafadaoweijiedan: "W", //是否下发
        xuanzekehu: "",
        xuanzekefu: "",
        yujiwanchengshijian: "", //预计完成时间
        yuanchenggongju: "", //远程工具
      },
      yuanchenggongjuName: "", //远程工具

      staffcopy: [],
      staff: [], //产品线
      staffz: [], //产品线
      shops: [], //检索的店铺
      allShops: [], //所有的店铺
      loading: false, //搜索加载状态
      scoped: false,

      /*表单规则 */
      formRule: {
        xuanzekehu: [
          {
            required: true,
            message: "请选择客户",
            // trigger: "blur"
          },
        ],
        lianxiren: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        lianxidianhua: [
          {
            required: true,
            message: "请输入电话",
            trigger: "blur",
          },
          {
            validator: checkMobile,
            min: 11,
            max: 11,
            message: "请正确填写自己得手机号，否则客服联系不上将无法为您服务。",
            trigger: "blur",
          },
        ],
        miaoshu: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        person: [
          {
            required: true,
            message: "请选择",
            trigger: "blur",
          },
        ],
        wentileixing: [
          {
            required: true,
            message: "请选择",
            trigger: "blur",
          },
        ],
        xiafadaoweijiedan: [
          {
            required: true,
            message: "请选择",
            trigger: "blur",
          },
        ],
        yuanchenggongju: [
          {
            required: true,
            message: "请填写",
            trigger: "blur",
          },
        ],
        yuanchengzhanghao: [
          {
            required: true,
            message: "请填写",
            trigger: "blur",
          },
        ],
        yuanchengmima: [
          {
            required: true,
            message: " ",
            trigger: "blur",
          },
        ],
        yujiwanchengshijian: [
          {
            required: true,
            message: "请选择",
            trigger: "blur",
          },
        ],
      },
      subCode: "",
    };
  },

  mounted() {
    // this.CreateSnowId();
    this.$nextTick(() => {
      this.$refs.xuanzekehu.focus();
    });
    this.qianyiyemingcheng = this.$route.query.qianyiyemingcheng;
    const that = this;
    window.onresize = () => {
      // return (() => {
      window.screenHeight = document.body.clientHeight;
      that.EchartsHeight = window.screenHeight - 200 + "px";
      // })()
    };
    if (this.juese == 13) {
      this.xiafadaoweijiedanList = [
        {
          Code: "W",
          Name: "未接单",
        },
        {
          Code: "Y",
          Name: "已接单",
        },
        {
          Code: "P",
          Name: "指定客服",
        },
      ];
      this.form = {
        miaoshu: "", //描述
        person: "", //产品线
        lianxiren: "",
        lianxidianhua: "",
        wentileixing: "", //问题类型
        xiafadaoweijiedan: "W", //是否下发
        xuanzekehu: "",
        xuanzekefu: "",
        yujiwanchengshijian: "", //预计完成时间
      };
    } else {
      this.xiafadaoweijiedanList = [
        {
          Code: "Y",
          Name: "否",
        },
        {
          Code: "W",
          Name: "是",
        },
      ];
      this.form = {
        miaoshu: "", //描述
        person: "", //产品线
        lianxiren: "",
        lianxidianhua: "",
        wentileixing: "", //问题类型
        xiafadaoweijiedan: "W", //是否下发
        xuanzekehu: "",
        xuanzekefu: "",
        yujiwanchengshijian: "", //预计完成时间
      };
    }

    this.addDate();
    this.getPerson();
    this.getWenTileixing();
    this.getYuanChengGongJu();
    this.currPage = 1;
    this.currPagekf = 1;
    this.handleAddItem(1);
  },
  activated() {
    this.qianyiyemingcheng = this.$route.query.qianyiyemingcheng;
    const that = this;
    window.onresize = () => {
      // return (() => {
      window.screenHeight = document.body.clientHeight;
      that.EchartsHeight = window.screenHeight - 200 + "px";
      // })()
    };

    this.addDate();
    this.getPerson();
    this.getWenTileixing();
    this.getYuanChengGongJu();
    this.currPage = 1;
    this.currPagekf = 1;
    this.handleAddItem(1);
  },

  methods: {
    CreateSnowId() {
      this.subCode = "";
      this.$request({
        method: "post",
        url: "Info/CreateSnowId",
      })
        .then((res) => {
          if (res.Code === "0") {
            this.subCode = res.Data;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    dianjichanpinxianSJ() {
      // this.yuanchenggongju="";
      this.staff = this.staffz;
    },
    yuanchenggongjuSJ() {
      // this.form.yuanchenggongju = "";
      this.YuanChengGongJuList = this.YuanChengGongJuListz;
    },
    // 监听粘贴操作
    handlePaste(event) {
      console.log(event);
      const items = (event.clipboardData || window.clipboardData).items;

      let file = null;
      if (!items || items.length === 0) {
        this.$message.error("当前浏览器不支持本地或请打开图片再复制");
        return;
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") !== -1) {
          file = items[i].getAsFile();

          break;
        }
      }
      if (!file) {
        this.$message.error("粘贴内容非图片");
        return;
      }
      var formRrcover = new FormData();
      console.log(file);
      formRrcover.append("image", file);
      formRrcover.append("processData", false);
      this.addFile(file); //预览
      // upLoadImgService.uploadCertificate(formRrcover).then(res => {
      // 	if (res.code === '0') {
      // 		const payImage = res.content[0]
      // 		this.payImageList.push(payImage)
      // 	}
      // })
    },
    addFile(file) {
      if (file.type.indexOf("image") >= 0) {
        var reader = new FileReader();
        var image = new Image();
        var _this = this;
        reader.readAsDataURL(file);

        reader.onload = function () {
          file.src = this.result;
          console.log(file);

          // image.onload = function() {
          // 	var width = image.width
          // 	var height = image.height
          // 	file.width = width
          // 	file.height = height
          // 	_this.imgList.push({
          // 		file
          // 	})
          // }
          image.src = file.src;

          const img = image.src;
          console.log("image.src", img, file);
          // _this.base64ImgtoFile(img)
          var filea = _this.base64ImgtoFile(img); // 得到File对象
          var imgUrl =
            window.webkitURL.createObjectURL(filea) ||
            window.URL.createObjectURL(filea);
          console.log(imgUrl);
          var div = {
            status: "ready",
            name: file.name,
            size: file.size,
            percentage: 0,
            uid: file.lastModified,
            raw: file,
            url: imgUrl,
          };
          // this.$refs['pictureUpload']['uploadFiles'].findIndex(item => item.uid === file.uid)

          _this.$refs["pictureUpload"]["uploadFiles"].push(div);
          _this.fileList.push(div.raw);
          _this.fileListhc.push(div);
          console.log(_this.fileList, _this.fileListhc);
          console.log(_this.$refs["pictureUpload"]["uploadFiles"]);
          // _this.$emit('base', file.src)
        };
      }
    },
    base64ImgtoFile(dataurl, filename = "file") {
      const arr = dataurl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const suffix = mime.split("/")[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime,
      });
    },

    dianjichanpinxianyc(e) {
      for (var i in this.YuanChengGongJuListz) {
        if (this.YuanChengGongJuListz[i].Code == e) {
          this.yuanchenggongjuName = this.YuanChengGongJuListz[i].Name;
        }
      }
      this.YuanChengGongJuList = this.YuanChengGongJuListz;
    },
    bindSelectChangeyc(val) {
      if (val) {
        this.YuanChengGongJuList = this.YuanChengGongJuListcopy.filter(
          (item) => {
            return PinyinMatch.match(item.Name, val); //(需要过滤的名称，输入的关键词)
          }
        );
      } else {
        this.YuanChengGongJuList = this.YuanChengGongJuListcopy;
      }
    },
    dianjichanpinxian() {
      this.staff = this.staffz;
      this.$nextTick(() => {
        this.$refs.wentileixing.focus();
      });
    },

    bindSelectChange(val) {
      if (val) {
        this.staff = this.staffcopy.filter((item) => {
          return PinyinMatch.match(item.Name, val); //(需要过滤的名称，输入的关键词)
        });
      } else {
        this.staff = this.staffcopy;
      }
    },
    addDate() {
      let nowDate = new Date();
      let date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate(),
      };

      if (date.month < 10) {
        date.month = "0" + date.month; //补齐
      }
      if (date.date < 10) {
        date.date = "0" + date.date; //补齐
      }
      // let shijianshuzu = [];
      let shijian = date.year + "-" + date.month + "-" + date.date;

      this.form.yujiwanchengshijian = shijian + " 23:59:59";
    },
    //客户双击
    handledbClick(row) {
      console.log("我走了handledbClick");

      this.kehumingcheng = row.BUSINESSNAME;
      this.kehubianhao = row.BUSINESSCODE;

      this.kehuId = row.BUSINESSID;
      this.form.lianxiren = "";
      this.lianxirenBY = row.CONTACT;
      this.lianxidianhuaBY = row.TELEPHONE;
      // this.form.lianxidianhua = row.TELEPHONE;
      // this.formDialogLXR = true;
      // this.formDialog = false;
      if (this.kehumingcheng != "" && this.kehubianhao != "") {
        this.form.xuanzekehu = this.kehumingcheng;
        this.XuanZeLianXiRen(1);
      } else {
        this.form.xuanzekehu = "";
      }

      // this.$nextTick(() => {
      // 	this.$refs.lianxiren.focus()
      // })
    },
    //客户双击
    handledbClickLXR(row) {
      console.log("我走了handledbClickLXR");

      // 	this.kehumingcheng = row.Contacts;
      // 	this.kehubianhao = row.ContactsInfo;
      this.form.lianxiren = row.Contacts;
      this.form.lianxidianhua = row.ContactsInfo;
      this.formDialogLXR = false;
      this.formDialog = false;
      if (this.kehumingcheng != "") {
        this.form.xuanzekehu = this.kehumingcheng;
      } else {
        this.form.xuanzekehu = "";
      }
      this.$nextTick(() => {
        this.$refs.chanpinxian.focus();
      });
    },
    /**查看分类下文档 */
    viewDoc(row) {
      // console.log("我走了viewDoc")
      // this.kehumingcheng = row.row.BUSINESSNAME;
      // this.kehubianhao = row.row.BUSINESSCODE;
      // this.form.lianxiren = row.row.CONTACT;
      // this.form.lianxidianhua = row.row.TELEPHONE;
      // this.formDialog = false;
      // if (this.kehumingcheng != "") {
      // 	this.form.xuanzekehu = this.kehumingcheng;
      // } else {
      // 	this.form.xuanzekehu = "";
      // }
      // this.$nextTick(() => {
      // 	this.$refs.lianxiren.focus()
      // })
      console.log("我走了handledbClick");

      this.kehumingcheng = row.row.BUSINESSNAME;
      this.kehubianhao = row.row.BUSINESSCODE;
      this.kehuId = row.row.BUSINESSID;
      this.form.lianxiren = "";
      this.lianxirenBY = row.row.CONTACT;
      this.lianxidianhuaBY = row.row.TELEPHONE;
      // this.form.lianxidianhua = row.row.TELEPHONE;
      // this.formDialogLXR = true;
      // this.formDialog = false;
      if (this.kehumingcheng != "" && this.kehubianhao != "") {
        this.form.xuanzekehu = this.kehumingcheng;
        this.XuanZeLianXiRen(1);
      } else {
        this.form.xuanzekehu = "";
      }
    },
    /**查看分类下文档 */
    viewDoclxr(row) {
      console.log("我走了viewDoclxr");
      // this.kehubianhao = row.row.ContactsInfo;
      this.form.lianxiren = row.row.Contacts;
      this.form.lianxidianhua = row.row.ContactsInfo;
      this.formDialogLXR = false;
      this.formDialog = false;
      if (this.kehumingcheng != "") {
        this.form.xuanzekehu = this.kehumingcheng;
      } else {
        this.form.xuanzekehu = "";
      }
      this.$nextTick(() => {
        this.$refs.chanpinxian.focus();
      });
    },
    //客服双击
    handledbClickkf(row) {
      if (row.ROLE_NAME == "客服") {
        this.kefumingcheng = row.NAME;
        this.kefubianhao = row.JOB_NUMBER;
        this.formDialogkf = false;
        if (this.kefumingcheng != "") {
          this.form.xuanzekefu = this.kefumingcheng;
        } else {
          this.form.xuanzekefu = "";
        }
      } else {
        this.$message({
          message: "仅可下发给客服！",
          type: "error",
        });
      }
    },
    /**查看分类下文档 */
    viewDockf(row) {
      this.kefumingcheng = row.row.NAME;
      this.kefubianhao = row.row.JOB_NUMBER;
      this.formDialogkf = false;
      if (this.kefumingcheng != "") {
        this.form.xuanzekefu = this.kefumingcheng;
      } else {
        this.form.xuanzekefu = "";
      }
    },
    uploadChange(file) {
      this.imgPreview(file);
      // this.imageFileData = file.raw;

      // console.log(JSON.stringify(this.fileListhc))
      // console.log(this.$refs['pictureUpload']['uploadFiles'])
    },
    imgPreview(file) {
      let self = this;

      // 看支持不支持FileReader
      if (!file.raw) return;

      if (/^image/.test(file.raw.type)) {
        // 看支持不支持FileReader
        if (!window.FileReader) return;
        // 创建一个reader
        let reader = new FileReader();

        reader.readAsDataURL(file.raw);

        // 读取成功后的回调
        reader.onloadend = function () {
          // 将图片2将转成 base64 格式
          let result = reader.result;
          // console.log("file.raw啊啊啊啊", result.length)

          if (result.length >= 55 * 1024 * 1024) {
            self.$message({
              message: "图片不可大于40M！",
              type: "error",
            });

            const indexa = self.$refs["pictureUpload"]["uploadFiles"].findIndex(
              (item) => item.uid === file.uid
            );
            self.$refs["pictureUpload"]["uploadFiles"].splice(indexa, 1);
            return;
          }
          let img = new Image();

          img.src = result;

          //判断图片是否大于100K,是就直接上传，反之压缩图片
          if (result.length <= 10 * 1024 * 1024) {
            // this.headerImage = this.result;
            self.fileList.push(file.raw);
            self.fileListhc.push(file);
            // self.postImg();
          } else {
            img.onload = function () {
              // this.fileList.push(file.raw);

              // console.log("file.raw啊啊啊啊", img)
              // this.fileListhc.push(file)
              let data = self.base64ImgtoFile(
                self.compress(img).replace(/^data:image\/png;base64,/g, "")
              );
              self.fileList.push(data);
              self.fileListhc.push(data);
              console.log("dataa啊啊啊", data, self.fileList, self.fileListhc);
              // this.headerImage = data;
              // self.postImg();
            };
          }
        };
      } else {
        self.fileList.push(file.raw);
        self.fileListhc.push(file);
      }
    },
    rotateImg(img, direction, canvas) {
      //最小与最大旋转方向，图片旋转4次后回到原方向
      const min_step = 0;
      const max_step = 3;
      if (img == null) return;
      //img的高度和宽度不能在img元素隐藏后获取，否则会出错
      let height = img.height;
      let width = img.width;
      let step = 2;
      if (step == null) {
        step = min_step;
      }
      if (direction == "right") {
        step++;
        //旋转到原位置，即超过最大值
        step > max_step && (step = min_step);
      } else {
        step--;
        step < min_step && (step = max_step);
      }
      //旋转角度以弧度值为参数
      let degree = (step * 90 * Math.PI) / 180;
      let ctx = canvas.getContext("2d");
      switch (step) {
        case 0:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0);
          break;
        case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, 0, -height);
          break;
        case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, -height);
          break;
        case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, 0);
          break;
      }
    },
    compress(img) {
      console.log("file.raw啊啊啊啊", img);
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      //瓦片canvas
      let tCanvas = document.createElement("canvas");
      let tctx = tCanvas.getContext("2d");
      let initSize = img.src.length;
      let width = img.width;
      let height = img.height;
      //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      let ratio;
      if ((ratio = (width * height) / 4000000) > 1) {
        console.log("大于400万像素");
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      //        铺底色
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      //如果图片像素大于100万则使用瓦片绘制
      let count;
      if ((count = (width * height) / 1000000) > 1) {
        console.log("超过100W像素");
        count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
        //            计算每块瓦片的宽和高
        let nw = ~~(width / count);
        let nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (let i = 0; i < count; i++) {
          for (let j = 0; j < count; j++) {
            tctx.drawImage(
              img,
              i * nw * ratio,
              j * nh * ratio,
              nw * ratio,
              nh * ratio,
              0,
              0,
              nw,
              nh
            );
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }

      //进行最小压缩
      let ndata = canvas.toDataURL("image/jpeg", 0.92);
      console.log("压缩前：" + initSize);
      console.log("压缩后：" + ndata.length);
      console.log(
        "压缩率：" + ~~((100 * (initSize - ndata.length)) / initSize) + "%"
      );
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },
    /**提交选项 */
    submitForm() {
      var jixuqingqiu = true;
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (
            this.form.miaoshu.length > 0 &&
            this.form.miaoshu.trim().length == 0
          ) {
            jixuqingqiu = false;
            this.$message({
              message: "描述不能为空！",
              type: "error",
            });
          } else {
            console.log(this.form.lianxiren);
            if (
              this.form.lianxiren == null ||
              this.form.lianxiren == undefined
            ) {
              jixuqingqiu = false;
              this.$message({
                message: "联系人不能为空！",
                type: "error",
              });
              return;
            } else {
              if (
                this.form.lianxiren.length > 0 &&
                this.form.lianxiren.trim().length == 0
              ) {
                jixuqingqiu = false;
                this.$message({
                  message: "联系人不能为空！",
                  type: "error",
                });
                return;
              }
            }

            if (
              this.form.lianxidianhua == null ||
              this.form.lianxidianhua == undefined
            ) {
              jixuqingqiu = false;
              this.$message({
                message: "联系电话不能为空！",
                type: "error",
              });
              return;
            } else {
              if (
                this.form.lianxidianhua.length > 0 &&
                this.form.lianxidianhua.trim().length == 0
              ) {
                jixuqingqiu = false;
                this.$message({
                  message: "联系电话不能为空！",
                  type: "error",
                });
                return;
              }

              var reg = /^1[3-9]\d{9}$/;
              if (!reg.test(this.form.lianxidianhua)) {
                this.$message({
                  message:
                    "请正确填写自己得手机号，否则客服联系不上将无法为您服务！",
                  type: "error",
                });
                // return;
              }
            }
            if (
              this.form.yuanchenggongju == null ||
              this.form.yuanchenggongju == undefined ||
              this.form.yuanchenggongju == ""
            ) {
              jixuqingqiu = false;
              this.$message({
                message: "远程方式不能为空！",
                type: "error",
              });
              return;
            } else {
              if (
                this.form.yuanchenggongju.length > 0 &&
                this.form.yuanchenggongju.trim().length == 0
              ) {
                jixuqingqiu = false;
                this.$message({
                  message: "远程方式不能为空！",
                  type: "error",
                });
                return;
              }
            }
            if (this.yuanchenggongjuName != "无") {
              if (
                this.yuanchengzhanghao == null ||
                this.yuanchengzhanghao == undefined ||
                this.yuanchengzhanghao == ""
              ) {
                jixuqingqiu = false;
                this.$message({
                  message: "远程账号不能为空！",
                  type: "error",
                });
                return;
              } else {
                if (
                  this.yuanchengzhanghao.length > 0 &&
                  this.yuanchengzhanghao.trim().length == 0
                ) {
                  jixuqingqiu = false;
                  this.$message({
                    message: "远程账号不能为空！",
                    type: "error",
                  });
                  return;
                }
              }

              if (
                this.yuanchengmima == null ||
                this.yuanchengmima == undefined ||
                this.yuanchengmima == ""
              ) {
                jixuqingqiu = false;
                this.$message({
                  message: "远程账号密码不能为空！",
                  type: "error",
                });
                return;
              } else {
                if (
                  this.yuanchengmima.length > 0 &&
                  this.yuanchengmima.trim().length == 0
                ) {
                  jixuqingqiu = false;
                  this.$message({
                    message: "远程账号密码不能为空！",
                    type: "error",
                  });
                  return;
                }
              }
            }

            // return

            if (
              !this.switchRemoteTool(
                this.form.yuanchenggongju,
                this.yuanchengzhanghao
              )
            ) {
              return;
            }

            if (this.kehumingcheng.length == 0) {
              jixuqingqiu = false;
              this.$message({
                message: "请选择客户！",
                type: "error",
              });
            } else {
              let formData = new FormData();
              let userInfo = JSON.parse(localStorage.getItem("userInfo"));
              console.log(this.fileList);
              var mingzia = "file";
              for (var i = 0, len = this.fileList.length; i < len; i++) {
                if (i == 0) {
                  formData.append(mingzia, this.fileList[i]);
                } else {
                  formData.append(mingzia + i, this.fileList[i]);
                }
              }

              if (this.form.xiafadaoweijiedan == "P") {
                if (this.kefubianhao == "") {
                  jixuqingqiu = false;
                  this.$message({
                    message: "请选择派单的客服！",
                    type: "error",
                  });
                }
              }
              this.isTiJiao = true;
              // var REMOTE_CIPHER = this.yuanchengmima;

              // if (
              //   this.yuanchengmima == null ||
              //   this.yuanchengmima == undefined ||
              //   this.yuanchengmima == ""
              // ) {
              //   REMOTE_CIPHER = "";
              // } else {
              //   if (
              //     this.yuanchengmima.length > 0 &&
              //     this.yuanchengmima.trim().length == 0
              //   ) {
              //     REMOTE_CIPHER = Buffer(this.yuanchengmima).toString("base64");
              //   }
              // }

              if (jixuqingqiu == true) {
                let data = {
                  FEEDBACK: {
                    ID: "",
                    CODE: "",
                    FEEDBACK_MESSAGE: "新建工单",
                    FEEDBACK_USER: userInfo.NAME,
                    CREATED_TIME: "",
                  },
                  ISSUED: this.form.xiafadaoweijiedan,
                  REMOTE_MODE: this.form.yuanchenggongju,
                  REMOTE_ACCOUNT: this.yuanchengzhanghao, //远程账号
                  REMOTE_CIPHER: Buffer(this.yuanchengmima).toString("base64"), //远程账号密码
                  PRODUCT_LINE: this.form.person, //产品线
                  INFO_TYPE: this.form.wentileixing, //工单类型
                  DESCRIBE: this.form.miaoshu, //工单描述
                  CONTACTS: this.form.lianxiren, //联系人
                  CONTACT_INFORMATION: this.form.lianxidianhua, //联系电话
                  CUSTOMER_NAME: this.kehumingcheng, //客户名称
                  CUSTOMER_NUMBER: this.kehubianhao, //客户编号
                  ESTIMATED_TIME: this.form.yujiwanchengshijian,
                  JOB_NUMBER: this.kefubianhao,
                  INFO_LEVEL: this.strNycd,
                };

                console.log(data,'data');
                

                localStorage.setItem("kfxinjiangongdan", JSON.stringify(data));
                formData.append("param", JSON.stringify(data));
                this.scoped = true;

                this.$request({
                  method: "post",
                  url: "Info/UploadInfo",
                  data: formData,
                })
                  .then(() => {
                    this.isTiJiao = false;
                    this.$message({
                      message: "发起成功！",
                      type: "success",
                      offset: 200,
                    });
                    this.form.xuanzekehu = "";
                    this.form.xuanzekefu = "";

                    if (this.juese == 13) {
                      this.form.xiafadaoweijiedan = "W";
                    } else {
                      this.form.xiafadaoweijiedan = "W";
                    }
                    var bdcpx = JSON.parse(
                      localStorage.getItem("userInfo")
                    ).PRODUCT_LINE.split(",");
                    for (var i in this.staff) {
                      for (var j in bdcpx) {
                        if (this.staff[i].Code == bdcpx[j]) {
                          if (this.form.person == "") {
                            this.form.person = this.staff[i].Code;
                          }
                        }
                      }
                    }

                    this.form.yuanchenggongju = "";
                    this.yuanchengzhanghao = "";
                    this.yuanchengmima = "";
                    // this.form.person = this.staff[0].Code;
                    this.form.wentileixing = this.WenTileixingList[0].Code;
                    this.form.miaoshu = "";
                    this.form.lianxiren = "";
                    this.form.lianxidianhua = "";
                    this.kehubianhao = "";
                    this.kehuId = "";
                    this.kehumingcheng = "";
                    this.$refs["pictureUpload"]["uploadFiles"] = [];
                    this.fileList = []; //移除已上传的图片
                    this.fileListhc = []; //移除已上传的图片
                    this.scoped = false;
                    localStorage.removeItem("kfxinjiangongdan");
                    // localStorage.removeItem("kfxinjiangongdantp");
                    // console.log(JSON.parse(localStorage.getItem("kfxinjiangongdan")))
                    // this.$router.push({ path: "weijiekongdan" });
                  })
                  .catch((err) => {
                    this.isTiJiao = false;
                    if (err == "Error: Request failed with status code 401") {
                      this.$router.push({
                        path: "/login",
                      });
                    }
                  });
              }
            }
          }
        } else {
          this.$message({
            message: "必填项不能为空！",
            type: "error",
          });
        }
      });
    },

    /**
     * @param {number} numberCount 远程工具类型
     * @param {string} value 远程账号
     */
    switchRemoteTool(numberCount, value) {
      const remoteTool = numberCount;
      const length = value.length;

      if (remoteTool == 301) {
        if (!(length >= 9 && length <= 10)) {
          this.$message({
            message: `请输入有效的9或10位远程账号`,
            type: "error",
          });
          return false;
        } else {
          return true;
        }
      } else if (remoteTool == 300 || remoteTool == 305) {
        if (length !== 9) {
          this.$message({
            message: `请输入有效的9位远程账号`,
            type: "error",
          });
          return false;
        } else {
          return true;
        }
      } else if (remoteTool == 302) {
        // if (length !== 9 || (/(\d)\1{8}/.test(value))) {
        //   this.$message({
        //     message: "请输入9位远程账号并且9位不能相同",
        //     type: 'error'

        //   });
        //   return false
        // } else {
        //   return true
        // }
        return true;
      } else {
        return true;
      }

      // switch (remoteTool) {
      //   case 301: // 向日葵：value长度是9或者10
      //   case 300: // 帮我把：value长度是9
      //   case 305: // ToDesk：value长度是9
      //     if (length !== 9 && (remoteTool !== 301 || length !== 10)) {
      //       this.$message({
      //         message: `请输入有效的${remoteTool === 301 ? "9或10位" : "9位"}远程账号`,
      //         type: 'error'
      //       })
      //       return false
      //     }
      //     break;
      //   case 302: // 远程桌面：value长度是9,9位数字相同不行
      //     if (length !== 9) {
      //       this.$message({
      //         message: "请输入9位远程账号",
      //         type: 'error'
      //       })
      //       return false
      //     }
      //     if (/(\d)\1{8}/.test(value)) { // 检查是否有9位数字相同
      //       this.$message({
      //         message: "远程账号不能有9位数字相同",
      //         type: 'warning'
      //       })
      //       return false
      //     }
      //     break;
      //   default:
      //     // uni.showToast({
      //     // 	title: "请输入有效的账号",
      //     // 	icon: 'none'
      //     // });
      //     return true
      // }
    },

    /**获取产品线 */
    getPerson() {
      this.loading = true;

      this.$request({
        method: "GET",
        url: "Dictionary/GetProducts",
      })
        .then((res) => {
          this.loading = false;
          if (res.Code == "0" || res.Code == 0) {
            var arr = [];

            var bdcpx = JSON.parse(
              localStorage.getItem("userInfo")
            ).PRODUCT_LINE.split(",");
            console.log(bdcpx);
            for (var zi in res.Data) {
              if (res.Data[zi].MnemonicCode == "SKZY") {
                arr.push(res.Data[zi]);
              }
            }
            for (var i in res.Data) {
              // for (var j in bdcpx) {

              // if (res.Data[i].Code == bdcpx[j]) {
              if (res.Data[i].MnemonicCode != "SKZY") {
                arr.push(res.Data[i]);
              }
              // 	}

              // }
              for (var j in bdcpx) {
                if (res.Data[i].Code == bdcpx[j]) {
                  if (this.form.person == "" || res.Data[i].Code == "1001") {
                    this.form.person = res.Data[i].Code;
                  }
                }
              }
            }
            this.staff = arr;
            this.staffz = arr;
            this.staffcopy = this.staff;

            if (JSON.parse(localStorage.getItem("kfxinjiangongdan")) != null) {
              this.form.xiafadaoweijiedan = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).ISSUED;
              this.form.yuanchenggongju = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).REMOTE_MODE;
              this.yuanchengzhanghao = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).REMOTE_ACCOUNT; //远程账号
              var mima = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).REMOTE_CIPHER; //远程账号密码
              this.yuanchengmima = Buffer(mima, "base64").toString();

              this.form.person = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).PRODUCT_LINE; //产品线
              this.form.wentileixing = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).INFO_TYPE; //工单类型
              this.form.miaoshu = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).DESCRIBE; //工单描述
              this.form.lianxiren = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).CONTACTS; //联系人
              this.form.lianxidianhua = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).CONTACT_INFORMATION; //联系电话
              this.kehumingcheng = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).CUSTOMER_NAME; //客户名称
              this.kehubianhao = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).CUSTOMER_NUMBER; //客户编号
              this.form.yujiwanchengshijian = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).ESTIMATED_TIME;
              // this.strNycd=JSON.parse(localStorage.getItem("kfxinjiangongdan"))
              // 	.ESTIMATED_TIME;
              this.form.xuanzekehu = this.kehumingcheng;
            }
          }
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });
    },
    /**获取客服名单 */
    getKefumingdan(index) {
      this.currPagekf = index;

      this.loading = true;
      this.isChaXunkfm = true;
      this.$request({
        method: "GET",
        url:
          "ACCOUNT/GetServiceAccountList?zh=" +
          encodeURIComponent(this.form.xuanzekefu) +
          "&status=-1&pageIndex=" +
          encodeURIComponent(index) +
          "&pageSize=" +
          encodeURIComponent(this.pageSizekf),
      })
        .then((res) => {
          this.isChaXunkfm = false;
          this.loading = false;
          if (res.Code == "0" || res.Code == 0) {
            this.tableDatakf = res.Data;
          }
          if (this.tableDatakf.length > 0) {
            for (var i in this.tableDatakf) {
              var bdcpx = this.tableDatakf[i].PRODUCT_LINE.split(",");
              var xin = [];
              for (var z in bdcpx) {
                for (var j in this.staff) {
                  if (bdcpx[z] == this.staff[j].Code) {
                    xin.push(this.staff[j].Name);
                    this.$set(
                      this.tableDatakf[i],
                      "PRODUCT_LINE1",
                      xin.join(",")
                    );
                  }
                }
              }
            }
          }
          this.allPagekf = res.Total;
        })
        .catch((err) => {
          this.isChaXunkfm = false;
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });
    },
    /**获取远程工具 */
    getYuanChengGongJu() {
      this.loading = true;

      this.$request({
        method: "GET",
        url: "Dictionary/GetRemoteTool",
      })
        .then((res) => {
          this.loading = false;
          if (res.Code == "0" || res.Code == 0) {
            this.YuanChengGongJuList = res.Data;
            this.YuanChengGongJuListcopy = this.YuanChengGongJuList;
            this.YuanChengGongJuListz = res.Data;
            if (JSON.parse(localStorage.getItem("kfxinjiangongdan")) != null) {
              this.form.xiafadaoweijiedan = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).ISSUED;
              this.form.yuanchenggongju = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).REMOTE_MODE;
              this.yuanchengzhanghao = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).REMOTE_ACCOUNT; //远程账号
              var mima = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).REMOTE_CIPHER; //远程账号密码
              this.yuanchengmima = Buffer(mima, "base64").toString();
              // this.yuanchengmima = ""
              this.form.person = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).PRODUCT_LINE; //产品线
              this.form.wentileixing = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).INFO_TYPE; //工单类型
              this.form.miaoshu = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).DESCRIBE; //工单描述
              this.form.lianxiren = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).CONTACTS; //联系人
              this.form.lianxidianhua = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).CONTACT_INFORMATION; //联系电话
              this.kehumingcheng = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).CUSTOMER_NAME; //客户名称
              this.kehubianhao = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).CUSTOMER_NUMBER; //客户编号
              this.form.yujiwanchengshijian = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).ESTIMATED_TIME;
              this.form.xuanzekehu = this.kehumingcheng;
            }
          }
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });
    },
    /**获取产品线 */
    getWenTileixing() {
      this.loading = true;

      this.$request({
        method: "GET",
        url: "Dictionary/GetGdLx",
      })
        .then((res) => {
          this.loading = false;
          if (res.Code == "0" || res.Code == 0) {
            this.WenTileixingList = res.Data;
            if (this.WenTileixingList.length > 0) {
              this.form.wentileixing = this.WenTileixingList[0].Code;
            }
            if (JSON.parse(localStorage.getItem("kfxinjiangongdan")) != null) {
              this.form.xiafadaoweijiedan = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).ISSUED;
              this.form.yuanchenggongju = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).REMOTE_MODE;
              this.yuanchengzhanghao = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).REMOTE_ACCOUNT; //远程账号
              var mima = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).REMOTE_CIPHER; //远程账号密码
              this.yuanchengmima = Buffer(mima, "base64").toString();
              // this.yuanchengmima = ""
              this.form.person = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).PRODUCT_LINE; //产品线
              this.form.wentileixing = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).INFO_TYPE; //工单类型
              this.form.miaoshu = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).DESCRIBE; //工单描述
              this.form.lianxiren = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).CONTACTS; //联系人
              this.form.lianxidianhua = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).CONTACT_INFORMATION; //联系电话
              this.kehumingcheng = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).CUSTOMER_NAME; //客户名称
              this.kehubianhao = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).CUSTOMER_NUMBER; //客户编号
              this.form.yujiwanchengshijian = JSON.parse(
                localStorage.getItem("kfxinjiangongdan")
              ).ESTIMATED_TIME;
              this.form.xuanzekehu = this.kehumingcheng;
            }
          }
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });
    },
    //联系人查询
    XuanZeLianXiRen(index) {
      this.loading = true;
      this.isChaXun = true;
      if (
        this.kehubianhao == null ||
        this.kehubianhao == undefined ||
        this.kehubianhao == ""
      ) {
        this.$message({
          message: "请先选择客户！",
          type: "error",
        });
        return;
      }
      this.$request({
        method: "GET",
        url:
          "/Contacts/GetHistoricalContactPageList?contacts=" +
          encodeURIComponent(this.form.lianxiren) +
          "&pageIndex=" +
          encodeURIComponent(index) +
          "&pageSize=" +
          encodeURIComponent(this.pageSizeLXR) +
          "&code=" +
          encodeURIComponent(this.kehubianhao),
      })
        .then((res) => {
          this.isChaXun = false;
          this.loading = false;
          if (res.Code == "0" || res.Code == 0) {
            console.log(res.Data);
            if (res.Data.length > 0) {
              this.tableDataLXR = res.Data;
              this.formDialogLXR = true;
            } else {
              this.$message({
                message: "没有查到联系人数据！",
                type: "error",
              });
              this.form.lianxiren = this.lianxirenBY;
              this.form.lianxidianhua = this.lianxidianhuaBY;
              this.formDialog = false;
              this.formDialogLXR = false;
            }
            this.KeHuXinXiChaXun(this.kehuId);
          }
          this.allPageLXR = res.Total;
        })
        .catch((err) => {
          this.isChaXun = false;
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });
    },
    //获取客户信息查询
    KeHuXinXiChaXun(rfid) {
      this.loading = true;
      this.isChaXun = true;
      this.CustomerInfo = [];
      this.$request({
        method: "GET",
        url: "/ACCOUNT/GetCustomerServiceInfo?rfid=" + encodeURIComponent(rfid),
      })
        .then((res) => {
          this.isChaXun = false;
          this.loading = false;
          if (res.Code == "0" || res.Code == 0) {
            console.log(res.Data);

            this.CustomerInfo = res.Data;
          }
          this.allPageLXR = res.Total;
        })
        .catch((err) => {
          this.isChaXun = false;
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });
    },
    //查询客户
    handleAddItem(index) {
      console.log("handleAddItem(index)", this.formDialog);
      this.loading = true;
      this.isChaXun = true;
      this.$request({
        method: "GET",
        url:
          "ACCOUNT/GetKhList?khxm=" +
          encodeURIComponent(this.form.xuanzekehu) +
          "&pageIndex=" +
          encodeURIComponent(index) +
          "&pageSize=" +
          encodeURIComponent(this.pageSize),
      })
        .then((res) => {
          this.isChaXun = false;
          this.loading = false;
          if (res.Code == "0" || res.Code == 0) {
            this.tableData = res.Data;
          }
          this.allPage = res.Total;
        })
        .catch((err) => {
          this.isChaXun = false;
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });
    },

    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.handleAddItem(1);
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.handleAddItem(this.currPage);
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.currPage = 1;
      this.handleAddItem(this.currPage);
    },
    /**分页size改变 */
    hanSiChangeLXR(val) {
      this.pageSizeLXR = val;
      this.XuanZeLianXiRen(1);
    },
    /**当前页改变 */
    hanCurrChangeLXR(val) {
      this.currPageLXR = val;
      this.XuanZeLianXiRen(this.currPage);
    },
    /**刷新表格数据 */
    handleRefreshLXR() {
      this.currPageLXR = 1;
      this.XuanZeLianXiRen(this.currPage);
    },
    /**分页size改变 */
    hanSiChangekf(val) {
      this.pageSizekf = val;
      this.currPagekf = 1;
      this.getKefumingdan(1);
    },
    /**当前页改变 */
    hanCurrChangekf(val) {
      this.currPagekf = val;
      this.getKefumingdan(this.currPagekf);
    },
    /**刷新表格数据 */
    handleRefreshkf() {
      this.currPagekf = 1;
      this.getKefumingdan(this.currPagekf);
    },

    double() {
      this.formDialog = true;
      console.log(this.form.xuanzekehu);
      if (this.form.xuanzekehu == undefined) {
        this.form.xuanzekehu = "";
      }
      this.handleAddItem(1);
      this.$nextTick(() => {
        this.$refs.kehuchaxun.focus();
      });
    },
    doublelxr() {
      // this.formDialogLXR = true
      // console.log(this.form.xuanzekehu)
      if (this.form.lianxiren == undefined) {
        this.form.lianxiren = "";
      }
      this.XuanZeLianXiRen(1);
      this.$nextTick(() => {
        this.$refs.lianxirenchaxun.focus();
      });
    },
    doublekf() {
      this.formDialogkf = true;
      this.getKefumingdan(1);
      this.$nextTick(() => {
        this.$refs.kefuchaxun.focus();
      });
    },
    sendMsg() {
      this.$emit("sendmsg", "firstpage");

      this.$emit("addnum", "firstpage");
    },
    handlebofangshipin(file) {
      this.bofangshipin = file.url;
      this.showShipinbofang = true;
    },
    handleRemove(file) {
      const index = this.fileList.findIndex((item) => item.uid === file.uid);
      const indexa = this.$refs["pictureUpload"]["uploadFiles"].findIndex(
        (item) => item.uid === file.uid
      );
      const indexhc = this.fileListhc.findIndex(
        (item) => item.uid === file.uid
      );
      this.$refs["pictureUpload"]["uploadFiles"].splice(indexa, 1);
      this.fileList.splice(index, 1); //移除已上传的图片
      this.fileListhc.splice(indexhc, 1); //移除已上传的图片
    },
    handlePictureCardPreview(file) {
      this.urlList = [];
      this.urlList.push(file.url);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      this.index = file.index;
      this.showViewer = true;
    },
    closeViewer() {
      this.dialogVisible = false;
    },

    fanhui() {
      this.$router.go(-1);
    },

    /**重置表单 */
    resetForm() {
      this.$refs.form.resetFields();
    },
    //回车事件
    xzlianxidianhua() {
      this.$nextTick(() => {
        this.$refs.lianxidianhua.focus();
      });
    },
    xzchanpinxian() {
      this.$nextTick(() => {
        this.$refs.chanpinxian.focus();
      });
    },
    xzwentileixing() {
      this.$nextTick(() => {
        this.$refs.wentileixing.focus();
      });
    },
    xiafaweijiedan() {
      this.$nextTick(() => {
        this.$refs.xiafaweijiedan.focus();
      });
    },
    xzyuanchenggongju() {
      this.$nextTick(() => {
        this.$refs.yuanchenggongju.focus();
      });
    },
    xzyuanchengzhanghao() {
      this.$nextTick(() => {
        this.$refs.yuanchengzhanghao.focus();
      });
    },
    xzyuanchengmima() {
      // this.$nextTick(() => {
      // 	this.$refs.yuanchengmima.focus()
      // })
    },
    xzmiaoshu() {
      this.$nextTick(() => {
        this.$refs.miaoshu.focus();
      });
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  background-color: #f0f0f0;
}

.containera {
  width: 100%;
  height: 100%;
  padding-left: 10px;
  margin-top: -10px;
  box-sizing: border-box;
  background-color: #ffffff;
}

.header {
  margin-top: 10px;
  margin-bottom: 15px;
  padding-left: 20px;
}

.headera {
  margin-bottom: 2px;
}

.fanhuiBtn {
  margin-top: 0px;
  margin-left: 0px;
  margin-bottom: 20px;
  display: inline-block;
}

.el-input {
  width: 100px;
}

.yonghuminglabe {
  margin-top: 30px;
  margin-left: 30px;
  margin-bottom: 0px;
  display: inline-block;
}

/* 主体容器 */
.main {
  height: 100%;
  overflow: hidden;
  background-color: #fff;
  padding: 0px;
  box-sizing: border-box;
}

.tijiaobtn {
  margin-left: 100px;
  margin-top: 30px;
  width: 100px;
  margin-bottom: 20px;
}

.header-con {
  margin-left: 50px;
  margin-right: 50px;
  margin-top: 30px;
}

.header-cona {
  display: flex;
  align-items: center;
  height: 30px;
  margin-left: 30px;
}

.header-con-form {
  display: flex;
  align-items: center;
}

.header-con-form-item {
  margin-bottom: 0;
}

.wenjianmingchengzs {
  position: absolute;
  z-index: 0;
  width: 100%;
  bottom: 0px;
  color: #ffffff;
  text-align: center;
  background-color: #3d546f;
}

/**输入框宽度 */
.form-item-input {
  width: 400px;
}

/**输入框后面的备注 */
.form-item-tip {
  display: inline-block;
  margin-left: 10px;
  color: #606266;
  font-size: 14px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.shangchuantupian {
  margin-left: 80px;
  margin-bottom: 20px;
  width: 80%;
}

/* 主体容器 */
.maina {
  height: 100%;
  /* overflow: hidden; */
  background-color: #fff;
  padding: 10px;
  box-sizing: border-box;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}

/* 主体容器 */
.mainxjgda {
  height: 100%;
  /* overflow: hidden; */
  background-color: #fff;
  padding: 0px;
  margin-top: 20px;
  box-sizing: border-box;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}

.el-card {
  box-shadow: 0 1px 1px #f5f5f5 !important;
}

.shangchuantupianx {
  margin-left: 10px;
  margin-top: 10px;

  display: inline-block;
}

.medium {
  width: 400px;
  height: 30px;
  text-align: left;
  color: #999999;
  font-weight: 400;
}

.mediuma {
  width: 400px;
  height: 30px;
  text-align: left;
  color: #333333;
  font-weight: 400;
}

/**输入框宽度 */
.form-item-inputcpx {
  width: 400px;
}

/deep/.eloption .el-select-dropdown__wrap {
  max-height: 400px !important;
}

.fankuiImage {
  width: 100%;
  height: 100%;
}

/deep/ .el-upload .el-upload-dragger {
  width: 100%;
  height: 100%;
  border: 1px dashed #ffffff;
}

.el-table {
  overflow-y: auto !important;
  overflow-x: auto !important;
}
</style>
